module.exports = __webpack_public_path__ + "media/components/lesson4/common/statics/image1-395ecf9402beddd78dfa20ac32f9de6b.jpg";